import {
    cleanItem,
    itemEditor,
} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {NcoaFailedCountLogic} from "./ncoa-failed-count-logic";
import {NcoaFailedLogic}      from "./ncoa-failed-logic";

export const ncoaFailedModules = ({item}) => [

    {
        name: "ncoaFailed1",
        load: ({}, next) => NcoaFailedLogic({item, next}),
        expo: [cleanItem],
    },
    {
        name: "ncoaFailed2",
        load: ({ncoaFailed1, enableAddressableShippingLogic2, ncoaFailedCount1}, next) => enableAddressableShippingLogic2?.state.value ? (
            ncoaFailed1.next({
                failedCount: ncoaFailedCount1.count,
                next,
            })
        ) : (
            next(null)
        ),
        requires: ["ncoaFailed1", "enableAddressableShippingLogic2", "ncoaFailedCount1"],
        expo: [itemEditor], // No need exporting UI, as this is accessed directly in top-control module
    },

    {
        name: "ncoaFailedCount1",
        load: ({mailingListIds}, next) => NcoaFailedCountLogic({
            mailingListIds,
            next,
        }),
        requires: ["mailingListIds"],
    },
    {
        name: "ncoaFailedCount2",
        load: ({ncoaFailedCount1, ncoaFailed2}, next) => (
            ncoaFailed2?.selected ? (
                ncoaFailedCount1.next({next})
            ) : (
                next(null)
            )
        ),
        requires: ["ncoaFailedCount1", "ncoaFailed2"],
        expo: [itemEditor],
    },
];